/**
 * @author Rosa
 */
import { BaseRouteService } from "./BaseRouteService";

export interface GetUsernameResponse {
    username: string | null;
}

export interface SaveUsernameResponse {
    available: boolean;
    message: string;
}

/**
 * UsernameService
 * Handling username-related API calls.
 * Extends the `BaseRouteService` to provide specific routes for username operations.
 * @class UsernameService
 * @extends BaseRouteService
 */
export class UsernameService extends BaseRouteService {
    /**
     * Sends a request to save the provided username.
     * @param {string} username - The username to save.
     * @returns {Promise<SaveUsernameResponse>} A promise resolving to the response of the save operation.
     * @async
     */
    public async saveUsername(username: string): Promise<SaveUsernameResponse> {
        return this.postJsonApi<SaveUsernameResponse>("game/username", { username });
    }

    /**
     * getUsername
     * @returns {Promise<GetUsernameResponse>} - A promise that resolves to the response containing the username.
     */
    public async getUsername(): Promise<GetUsernameResponse> {
        return this.getJsonApi<GetUsernameResponse>("game/username");
    }
}
